// Avtalet som egen sida, /villkor och /bitradesavtal (ADR 0100). Sidan kräver
// ingen inloggning, så att byrån kan läsa avtalen innan den godkänner dem.
import type { AgreementKind } from '@leadledger/domain';
import { useEffect } from 'react';
import { Link } from 'react-router';
import { Marke } from '../../layout/ikoner.js';
import { Markdown } from './Markdown.js';
import { AGREEMENTS, AVTALSTEXT } from './texter.js';

export function AvtalSida({ sort }: { sort: AgreementKind }) {
  const { name } = AGREEMENTS[sort];
  useEffect(() => {
    document.title = `${name} – LeadLedger`;
  }, [name]);
  return (
    <div className="avtal">
      <header className="kom-igang-huvud">
        <Link className="marke" to="/">
          <Marke />
          LeadLedger
        </Link>
      </header>
      <main id="innehall" className="avtal-sida" aria-labelledby="avtal-rubrik">
        <Markdown text={AVTALSTEXT[sort]} rubrikId="avtal-rubrik" />
        <p>
          <Link to="/">Till kontot</Link>
        </p>
      </main>
    </div>
  );
}
